/*! towsons-options-app.js — keeps the old personalisation app off the page.
 *
 * The app is installed shop-wide through a script tag, so switching its theme
 * block off does not stop it: it finds its own container and fills it. On a
 * theme that has its own personaliser and its own treats picker, that means
 * the shopper sees two of everything.
 *
 * The stylesheet hides the container so nothing flashes; this removes it,
 * along with the inputs it puts in the add-to-cart form, so nothing of the
 * app's reaches the basket. It keeps watching, because the app injects late
 * and again after the theme redraws a section.
 */
(function () {
  'use strict';
  var SELECTOR = '#infiniteoptions-container, .infiniteoptions-no-atc-warning-wrapper, [id^="infiniteoptions-"], [class^="infiniteoptions-"]';

  function kill() {
    var els = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < els.length; i++) {
      if (els[i].parentNode) els[i].parentNode.removeChild(els[i]);
    }
    return els.length;
  }

  kill();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', kill);
  document.addEventListener('shopify:section:load', kill);
  if ('MutationObserver' in window) {
    var start = function () {
      var t = null;
      new MutationObserver(function () { clearTimeout(t); t = setTimeout(kill, 40); })
        .observe(document.body, { childList: true, subtree: true });
    };
    if (document.body) start(); else document.addEventListener('DOMContentLoaded', start);
  }
  window.TowsonsOptionsApp = { evict: kill };
})();
